import { Component, ViewChild } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { HomePage } from './home/home.page';
import { UserService } from 'src/app/services/user.service';
import { KilnService } from 'src/app/services/kiln.service';
import { StorageService } from './services/storage.service';
import { PushNotificationService } from './services/push-notification.service';
import {
  TranslateService,
  TranslatePipe,
  TranslateDirective
} from "@ngx-translate/core";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  rootPage:any = HomePage;
  @ViewChild('myNav') nav;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private userService: UserService,
    private kilnService: KilnService,
    private storageService: StorageService,
    private translate: TranslateService,
    private pushNotificationService: PushNotificationService
  )
  {
    // Set default language
    this.translate.addLangs(['en', 'fr', 'de']);
    this.translate.setFallbackLang('en');
    
    // Load saved language preference
    this.storageService.get('preferredLanguage')?.then((lang: string) => {
      if (lang && ['en', 'fr'].includes(lang)) {
        this.translate.use(lang);
      } else {
        this.translate.use('en');
        this.storageService.set('preferredLanguage', 'en');
      }
    }).catch((err) => {
      console.error('Error getting preferred language:', err);
      this.translate.use('en');
      this.storageService.set('preferredLanguage', 'en');
    });

    let statusBarAndSplashScreenOnReady = () => {
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(true);
      this.splashScreen.hide();
      // Create Android FCM channel at startup so it exists before any push registration or incoming FCM
      this.pushNotificationService.ensureAndroidChannelExists();
      // Register for push at startup only on devices that support it (skips browser/desktop where Cordova push plugin is not available)
      if (this.pushNotificationService.isPushAvailable) {
        this.pushNotificationService.registerAtStartupIfAvailable().catch(() => {});
      } else {
        console.log('Push not available.  Cordova not loaded.');
      }
    };

    platform.ready().then(statusBarAndSplashScreenOnReady);
  }

  setPlatformListener() {
    this.platform.resume.subscribe(async () => {
      this.userService.getStoredEmail();
      this.userService.getStoredPassword();
      this.kilnService.startTimerSecond(); //start the second timer which will always run

      this.storageService.get('email').then((email_val) => {
        this.storageService.get('password').then((pwd_val) => {
          if(email_val && pwd_val) {
            this.userService.tryLogin(email_val, pwd_val).subscribe(() => {
              this.kilnService.setTimerSecond(1);
              this.userService.setTimerSecond(1);
            });
          }
        });
      });
    });
  }
}
